import { render, staticRenderFns } from "./avignonesi.vue?vue&type=template&id=a17580f8&scoped=true"
import script from "./avignonesi.vue?vue&type=script&lang=js"
export * from "./avignonesi.vue?vue&type=script&lang=js"
import style0 from "./avignonesi.vue?vue&type=style&index=0&id=a17580f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17580f8",
  null
  
)

export default component.exports